"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerFooterClassNames: function() {
        return drawerFooterClassNames;
    },
    useDrawerFooterStyles_unstable: function() {
        return useDrawerFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerFooterClassNames = {
    root: 'fui-DrawerFooter'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1snvl2j", null, [
    ".r1snvl2j{width:100%;max-width:100%;padding:var(--spacingVerticalL) var(--spacingHorizontalXXL) var(--spacingVerticalXXL);display:flex;justify-content:flex-start;align-items:center;column-gap:var(--spacingHorizontalS);box-sizing:border-box;position:relative;z-index:2;}"
]);
const useDrawerFooterStyles = /*#__PURE__*/ (0, _react.__styles)({
    separator: {
        Bbc2r3f: "fhufbb2",
        xx9plb: "fxf9f1y",
        qd6xl9: [
            "fmlx6bj",
            "f1t0u0az"
        ],
        Byque4d: [
            "f1t0u0az",
            "fmlx6bj"
        ],
        ngabwx: "f1429bq1",
        B1dvbpk: "fv3cwj",
        B5szp9g: "f1ayei5p",
        iukgx1: "fkgtggm",
        Br7k87z: "f44t985",
        rurcny: "fuzzvh5",
        Bf8kmfk: "f14oqhab"
    },
    separatorVisible: {
        ngabwx: "f3ve9t9"
    }
}, {
    d: [
        ".fhufbb2:before{height:1px;}",
        ".fxf9f1y:before{position:absolute;}",
        ".fmlx6bj:before{right:0;}",
        ".f1t0u0az:before{left:0;}",
        ".f1429bq1:before{opacity:0;}",
        ".fv3cwj:before{background-color:var(--colorNeutralStroke1);}",
        ".f1ayei5p:before{transition-duration:var(--durationNormal);}",
        ".fkgtggm:before{transition-property:opacity;}",
        ".f44t985:before{transition-timing-function:var(--curveEasyEase);}",
        ".fuzzvh5:before{content:\"\";}",
        ".f14oqhab:before{top:0;}",
        ".f3ve9t9:before{opacity:1;}"
    ]
});
const useDrawerFooterStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const rootStyles = useDrawerFooterStyles();
    state.root.className = (0, _react.mergeClasses)(drawerFooterClassNames.root, styles, state.scrollState !== 'none' && rootStyles.separator, [
        'middle',
        'top'
    ].includes(state.scrollState) && rootStyles.separatorVisible, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerFooterStyles.styles.js.map
